import * as React from "react"
import { Box } from "@mui/material";
import { SelectSeeker } from "@ui-seeker/core";

import {DATE_PERIODS} from "@constants";
import {DateRangeBlock} from "@components";
import {kpiSelected, evolutionCurrentPeriod} from "../@signals";
import {rangeDatesPPKpi} from "./Ranges";


export default function ProductPageKPIEvolutionChartToolbar({options, dateRange, onChange}) {

    return <Box sx={{ display: 'flex', gap: 2,  alignItems: 'center'}}>
        <DateRangeBlock
            currentPeriodLabel={evolutionCurrentPeriod.value}
            maxDays={30}
            value={dateRange}
            ranges={rangeDatesPPKpi}
            onChange={onChange}
            onOk = { () => evolutionCurrentPeriod.value = DATE_PERIODS.CUSTOM }
        />
        <SelectSeeker
            options={options}
            value={kpiSelected.value}
            onChange = { e => kpiSelected.value = e.target.value }
        />
    </Box>
}

